import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import AddCategory from "./AddCategory";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
const columns = [
  {
    id: "createdAt",
    label: "Created Date",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "name",
    label: "Category Name",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "type",
    label: "Category Type",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center" as const,
  },
];

const Category = () => {
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryIdToDelete, setCategoryIdToDelete] = useState<string | null>(
    null
  );
  const [categoryToEdit, setCategoryToEdit] = useState<any | null>(null);
  const [categories, setCategories] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);
  const [type, setType] = useState("ALL");
  const typeRef = useRef<string>("");
  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    name: "name",
    type: "type",
    createdAt: "createdAt",
  };
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getCategories(searchRef.current, typeRef.current);
  }, [currentPage, sortField, sortOrder]);

  const categoryTypes = [
    // { id: "EVENT", label: "Event" },
    // { id: "MEMBER", label: "Member" },
    { id: "ORGANIZATION", label: "Organization" },
    { id: "GET_TOUCH", label: "Get in Touch" },
    { id: "GALLERY", label: "Gallery" },
    { id: "INDUSTRY_REPORT", label: "Industry Report" },
    { id: "TENDERS", label: "Tenders" },
    { id: "PRESENTATION", label: "Presentation" },
    { id: "KNW_PAPER", label: "Monthly Report" },
    { id: "RESOURCE_INDEX", label: "Index" },
    { id: "WORKING_GROUP", label: "Working Group" },
    { id: "REGULATION", label: "Representations" },
  ];

  const getCategories = (keyword: string = "",typeId = "") => {
    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    // Status filter
    if (search && search !== "ALL") {
      params.append("status", search);
    }

    // Keyword search
    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }

    if (typeId) {
      params.append("type", typeId);
    }

    // Sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);
    WebService.getAPI({
      action: `categories/getCategories?${params.toString()}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        for (let i in res?.data?.data) {
          res.data.data[i].createdAt = HelperService.getFormatedDate(
            res.data.data[i].createdAt
          );
          const rawType = res.data.data[i].type;
          const formattedType = rawType
            ? rawType
                .toLowerCase()
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l: string) => l.toUpperCase())
            : "";
          res.data.data[i].type =
            rawType === "KNW_PAPER"
              ? "Monthly Report"
              : rawType === "RESOURCE_INDEX"
                ? "Index"
                : rawType === "REGULATION"
                ? "Representations"
                : formattedType;
          res.data.data[i].action = (
            <div>
              {perm.canEdit && (
                <PencilFill
                  title="Edit"
                  className="me-3 cursor-pointer"
                  onClick={() => {
                    setShowAddCategory(true);
                    setCategoryToEdit({ ...res.data.data[i], type: rawType });
                  }}
                />
              )}
              {perm.canDelete && (
                <TrashFill
                  title="Delete"
                  color="#DC143C"
                  className="cursor-pointer"
                  onClick={() => handleDeleteEvent(res.data.data[i]._id)}
                />
              )}
            </div>
          );
        }
        setCategories(res?.data?.data);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {});
  };

  const handleDeleteEvent = (categoryId: string) => {
    setCategoryIdToDelete(categoryId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddCategory
        show={showAddCategory}
        handleClose={() => {
          setShowAddCategory(false);
          setCategoryToEdit(null);
          getCategories(searchRef.current, typeRef.current);
        }}
        data={categoryToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (categoryIdToDelete) {
            WebService.deleteAPI({
              action: `categories/deleteCategory/${categoryIdToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getCategories(searchRef.current, typeRef.current);
            });
          }
        }}
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Category</div>
            {pagePermission.canAdd && (
              <CustomButton
                isLoading={false}
                label="Add Category"
                onClick={() => {
                  setShowAddCategory(true);
                }}
                style={{ width: 180 }}
              />
            )}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name or type"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;                  
                  setSearch(value );
                  setCurrentPage(1);
                  getCategories(searchRef.current, typeRef.current);
                }}
              />
            </div>
            <div className="col-md-3">
              <Form.Label className="label">Type</Form.Label>
              <Form.Select
                value={type}
                onChange={(e) => {
                  // const selectedType = e.target.value;
                  // setType(selectedType);
                  // setCurrentPage(1);
                  // getMediaTags(
                  //   search,
                  //   selectedType === "ALL" ? "" : selectedType,
                  // );
                  const selectedType = e.target.value;
                  const finalType = selectedType === "ALL" ? "" : selectedType;

                  typeRef.current = finalType;
                  setType(selectedType);
                  setCurrentPage(1);
                  getCategories(searchRef.current, typeRef.current);                  
                }}
              >
                <option value="ALL">All</option>
                {categoryTypes.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
          <CustomTableSortable
            columns={columns}
            rows={categories}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);
              setCurrentPage(1);
              // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default Category;
